<template>
  <v-dialog persistent max-width="720" :value="value" v-on="$listeners">
    <v-sheet class="nx-onboarding-features-dialog">
      <v-carousel
        class="nx-onboarding-features-dialog-carousel"
        hide-controls
        :cycle="false"
        :height="$vuetify.breakpoint.xsOnly ? 303 : 367"
        v-model="slideIndex"
      >
        <v-carousel-item
          v-for="feature in features"
          :key="feature.id"
          :src="$vuetify.breakpoint.xsOnly ? feature.mobileImage : feature.image"
        />
      </v-carousel>
      <v-layout column class="nx-onboarding-features-dialog-content">
        <h2 class="nx-onboarding-features-dialog-title" v-html="currentSlide.title"/>
        <p class="nx-onboarding-features-dialog-text" v-html="currentSlide.description"/>
      </v-layout>
      <v-layout row class="nx-onboarding-features-dialog-buttons">
        <template v-if="endSlideReached">
          <v-btn
            color="secondary"
            flat
            @click="close"
          >{{ $t('message.common.finish') }}
          </v-btn>
        </template>
        <template v-else>
          <v-btn color="secondary"
                 flat
                 @click="close"
          >{{ $t('message.common.omit') }}
          </v-btn>
          <v-btn
            color="secondary"
            flat
            @click="next"
          >{{ $t('message.common.next') }}
          </v-btn>
        </template>
      </v-layout>
    </v-sheet>
  </v-dialog>
</template>

<script>
export default {
  name: 'nx-onboarding-features-dialog',
  props: {
    value: Boolean,
    features: Array,
  },
  data() {
    return {
      slideIndex: 0,
    };
  },
  computed: {
    currentSlide() {
      return this.features[this.slideIndex] || {};
    },
    endSlideReached() {
      return this.slideIndex === this.features.length - 1;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    next() {
      if (this.endSlideReached) return;
      this.slideIndex += 1;
    },
  },
};
</script>

<style lang="stylus">
@import '../../../assets/stylus/variables.styl'

.nx-onboarding-features-dialog {
  &-carousel {
    box-shadow: none;
  }

  &-content {
    padding: 30px 20px 15px
    @media $xs-only {
      padding: 20px 20px 30px
    }
  }

  &-title {
    color: $info;
    text-align: center;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 500;
  }

  &-text {
    margin: 15px 0 0;
    font-size: 15px;
  }

  &-buttons {
    height: 58px;
    align-items: center;
    justify-content: flex-end;
  }

  .v-carousel__controls {
    background: none;

    .v-carousel__controls__item {
      &:before {
        opacity: 0.6;
        color: white;
      }

      .v-icon {
        opacity: 0.3;
        color: black;
        font-size: 24px !important;
      }

      &.v-btn--active .v-icon {
        opacity: 0.8;
      }
    }
  }
}
</style>
